// extracted by mini-css-extract-plugin
module.exports = {"loading":"trade_loading__4Qdkj"};